import { formatCurrency as $formatCurrency } from "@npco/web-utils";

/**
 * Imposes stricter parameters for `formatCurrency` from "@npco/web-utils".
 */
export const formatCurrency = $formatCurrency as (opts: {
	amountInCents: number;
	currency?: string;
}) => string;
